import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function logout() {
  await axios.delete(routes.logout, AXIOS_DEFAULT_CONFIG);
}
